export default {
      id: "icon-pate-ours-usage",
      viewBox: "0 0 98.1 124.4",
      url: __webpack_public_path__ + "icons.svg#icon-pate-ours",
      toString: function () {
        return this.url;
      }
    }